function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, [{
    key: "logDisabled",
    value: function logDisabled() {
      return true;
    }
  }, {
    key: "execute",
    value: function execute(properties, component) {
      var _this = this;

      if (Utils.settings.isDev) {
        return;
      }

      var firebase = window.firebase;

      if (Utils.type.isObject(firebase)) {
        var params = properties.params;
        var suffix = params.referer_group ? "w/ referer" : "w/o referer";
        params.build_env = Utils.settings.env; // params.build_version = Utils.settings.appVersion;

        console.log("Logging ".concat(suffix, ":"), properties.name, params);
        firebase.analytics().logEvent(properties.name, params);
      } else {
        console.log("Waiting for firebase to be initialized...");
        setTimeout(function () {
          _this.execute(properties);
        }, 100);
      }
    }
  }]);

  return _default;
}();

export { _default as default };